import { ProductAPI } from "../api";

export class Product {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async getProducts(payload) {
    const { data } = await ProductAPI.getProducts(payload);
    data.result.map((item) => new Product(item));
    return data.result;
  }
  static async createProduct(payload) {
    const { data } = await ProductAPI.createProduct(payload);
    // Array Return
    // data.result.map((item) => new Product(item));
    // Object Return
    data.result = new Product(data.result);
    return data.result;
  }
  static async updateProduct(payload) {
    const { data } = await ProductAPI.updateProduct(payload);
    // Array Return
    // data.result.map((item) => new Product(item));
    // Object Return
    data.result = new Product(data.result);
    return data.result;
  }
  static async removeProduct(id) {
    const { data } = await ProductAPI.removeProduct(id);
    data.result = new Product(data.result);
    return data.result;
  }
}
